export const projectsData = [
  {
    id: "neurosyn",
    title: "NeuroSyn",
    icon: "neurosyn",
    category: "iOS & Cognitive Analytics",
    tech: "Swift 6, SwiftUI, HealthKit, ScreenTime",
    description: "A proprietary iOS application that correlates digital media telemetry (TikTok watch history & ScreenTime) with Apple HealthKit biometrics to predict cognitive fatigue and optimize sleep recovery.",
    highlights: ["Apple HealthKit Biometric Sync", "TikTok Telemetry & Watch Analyzer", "ScreenTime & Sleep Correlation Engine"],
    status: "Private Beta"
  },
  {
    id: "discordbots",
    title: "Discord Bots",
    icon: "discord",
    category: "Bots",
    tech: "Node.js, Discord.js v14, Python, SQLite",
    description: "Production Discord bot engine engineered for live lyrics visualization (Lyrika-Stanza) with millisecond offset controls and 24/7 cloud deployment.",
    highlights: ["Lyrika-Stanza Live Lyric Engine", "24/7 Wispbyte Deployment"],
    status: "View >",
    bots: [
      {
        id: "bot-0",
        slug: "lyrika-stanza",
        name: "Lyrika-Stanza",
        tag: "Music & Live Lyrics",
        status: "Active (Wispbyte)",
        description: "Synchronized, real-time scrolling lyrics for voice channel music bots (Chip, Jockie, FredBoat). Features live latency sync controls.",
        fullDescription: "Lyrika-Stanza is a specialized Discord bot that provides synchronized, real-time scrolling lyrics for music playing in your voice channels. It detects tracks played by music bots and streams live lyrics directly into text chat with interactive timing offset controls.",
        features: ["Live Scrolling Lyrics with Focus Frame Target", "Interactive Latency Sync (-0.5s / +0.5s)", "Bot Agnostic Track Parsing (Chip, Jockie, FredBoat)", "Zero-config SQLite Multi-server Architecture"],
        commands: ["/setup-lyrics [listen] [output]", "/set-targetbot [bot]", "/setoffset [offset-ms]", "/status"],
        architecture: "Discord.js v14.15 event-driven engine with SQLite multi-server config store optimized for 24/7 deployment on Wispbyte.",
        tech: "Discord.js v14, Node.js, SQLite, Wispbyte",
        repoUrl: "https://github.com/NottKoneko/Lyrika-Stanza/tree/wispbyte",
        supportServerUrl: null,
        theme: "pink"
      }
    ]
  },
  {
    id: "tamed",
    title: "Tamed",
    icon: "tamed",
    category: "Web Applications",
    isCommission: true,
    tech: "React 19, Vite 6, Zustand 5, Supabase, Cloudflare Pages",
    description: "Full-stack gamified accountability & routine tracking web application with real-time Supabase synchronization, dual-role dashboards, and Zustand state persistence.",
    highlights: [
      "Gamified Routine Checklists & XP Engine (+25 XP/task)",
      "Dual-Role Dashboard Architecture (Manager & Partner)",
      "Real-Time Supabase PostgreSQL & RLS Security Isolation",
      "Cryptographic 6-Digit Pair Auth & Offline Fallback"
    ],
    status: "Active",
    liveUrl: "https://tamed.pages.dev/",
    repoUrl: "https://github.com/NottKoneko/Tamed",
    wikiUrl: "https://github.com/NottKoneko/Tamed/wiki"
  },
  {
    id: "website-templates",
    title: "Website Templates",
    icon: "templates",
    category: "Web Applications",
    tech: "Vanilla HTML5, CSS3, ES6 JavaScript, Web Visual Editors",
    description: "Free, drop-in personal landing pages and link directories for creators, streamers, and developers. Zero npm dependencies, in-browser visual customizers, and free edge hosting.",
    highlights: [
      "Zero-Build Vanilla Stack (No npm, no bundlers)",
      "Interactive In-Browser Visual Editors (editor.html)",
      "Single-File Config Customization (config.js)",
      "Free Static Hosting (GitHub Pages & Cloudflare)"
    ],
    status: "Active",
    liveUrl: "https://templates.notkoneko.space/",
    repoUrl: "https://github.com/NottKoneko/WebsiteTemplates-",
    templates: [
      {
        id: "retro-pastel-profile",
        name: "Retro Pastel Profile",
        tag: "Faux Browser & Creator Profile",
        description: "A cozy, retro desktop/browser style profile page with sidebars, links directory, schedule widgets, and commission board.",
        liveUrl: "https://templates.notkoneko.space/retro-pastel-profile/",
        editorUrl: "https://templates.notkoneko.space/retro-pastel-profile/editor.html",
        repoUrl: "https://github.com/NottKoneko/WebsiteTemplates-/tree/main/retro-pastel-profile",
        features: [
          "Retro faux-browser header with interactive window buttons & copy address bar",
          "3-column layout (bio sidebar, categorized links, schedule & widgets)",
          "Dedicated commissions page with tiered rules and heart bullet points",
          "Visual template editor with live canvas inspection and config export"
        ]
      },
      {
        id: "pages-style",
        name: "Pages Style",
        tag: "Editorial Creator Portfolio",
        description: "A bold, high-contrast monochrome editorial portfolio, commission guide, lore board, and client inquiry portal for digital creators.",
        liveUrl: "https://templates.notkoneko.space/pages-style/",
        editorUrl: "https://templates.notkoneko.space/pages-style/editor.html",
        repoUrl: "https://github.com/NottKoneko/WebsiteTemplates-/tree/main/pages-style",
        features: [
          "6 modular sections: Hero, Lore & Timeline, Commissions, TOS, Gallery, Contact Form",
          "Editorial typography pairing Google Fonts Tajawal & Shrikhand with starfield canvas",
          "Inquiry portal with multi-channel support (built-in form, email launcher, external link)",
          "Visual editor with one-click page toggles, tier reordering, and direct config export"
        ]
      }
    ]
  },
  {
    id: "spotify-controller",
    title: "Spotify HID Hardware Controller",
    icon: "spotify",
    category: "Hardware & C++",
    tech: "C++, Node.js, Custom Plugins",
    description: "A hardware-to-software interface mapping the volume knob of a standard HID keyboard directly to Spotify's API for isolated audio control.",
    highlights: ["Direct HID USB Interfacing", "Spotify REST API Integration", "Custom Plugin Architecture"],
    status: "Deployed"
  }
];
